(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-drawer"] && !Shopify.designMode) return;
  try {
    class SizeGuideTable extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('.size-guide__unit-toggle');
      this.dropdown = this.querySelector('.size-guide__unit-dropdown');
      this.unitValue = this.querySelector('.size-guide__unit-value');
      this.options = this.querySelectorAll('.size-guide__unit-option');
      this.circumferences = this.querySelectorAll('.size-guide__circumference');

      if (!this.toggle) return;

      this.toggle.addEventListener('click', this.#handleToggleClick.bind(this));
      this.options.forEach((option) => {
        option.addEventListener('click', this.#handleOptionClick.bind(this));
      });

      document.addEventListener('click', this.#handleOutsideClick.bind(this));
    }

    #handleToggleClick(event) {
      event.stopPropagation();
      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      this.toggle.setAttribute('aria-expanded', !expanded);
    }

    #handleOptionClick(event) {
      const selectedUnit = event.currentTarget.dataset.unit;

      this.options.forEach((option) => {
        option.setAttribute('aria-pressed', option.dataset.unit === selectedUnit);
      });

      this.circumferences.forEach((circ) => {
        circ.hidden = circ.dataset.unit !== selectedUnit;
      });

      this.unitValue.textContent = selectedUnit;
      this.unitValue.dataset.unit = selectedUnit;

      this.toggle.setAttribute('aria-expanded', 'false');
    }

    #handleOutsideClick(event) {
      if (!this.contains(event.target)) {
        this.toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }

  if (!customElements.get('size-guide-table')) {
    customElements.define('size-guide-table', SizeGuideTable);
  }
  } catch(e) { console.error(e); }
})();

})();
